export default __webpack_public_path__ + "static/media/Black Water Disposal - Coral.9cf96f63.svg";